
import './Header.css';
import React from "react";

function Header(props) {
    return (
        <div className="header">
            <h1 className="leftAligned headerText"> MINIMALLY PROCESSED </h1>
            <p className="leftAligned subheaderText"> Eating should be easy. So why isn’t it? Because we’ve allowed ultra-processed foods to destroy us. Break the toxic cycle - try minimally processed.  </p>
        </div>
    )
}

export default Header;